// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rrEJ","toggleWrap":"styles_toggleWrap__3Kmln","content":"styles_content__3zexs","selectAreaCode":"styles_selectAreaCode__12wKN"};